
import * as React from 'react';
import { ItemDefaultDropAction, IItemDefaultDropActionProps } from '../actions/defaultDrop/DefaultDropAction';
import {
    asActionDropZone,
    IDecorateAsActionDropZoneProps,
    IActionDropZoneStateProps,
    DEFAULT_ACTION_DROP_ZONE_STATE_PROPS
} from '../decorators/asActionDropZone';
import { isFileDropEvent } from '../../utilities/dragAndDrop/files';
import { withCurrentItem, IDecorateWithCurrentItemProps } from '../decorators/selectors';
import { connectToItemCache } from '../decorators/connectToItemCache';
import { IItemCache } from '../../models/IItemCacheObserver';
import { itemDragDropControl } from '../../controls/itemDragDropControl';
import { evaluateAction, ISelectedActionProps, ActionSelector } from '../withAction/WithAction';
import { renderChildrenWithProps } from '../../utilities/components/RenderProps';

export type IItemDefaultDropZoneProps = IDecorateAsActionDropZoneProps<IItemDefaultDropActionProps, {
    /**
     * The index of the item within a backing list, if applicable.
     */
    itemIndex?: number;
}>;

const ItemActionDropZone = asActionDropZone(isFileDropEvent)(ItemDefaultDropAction);

export const ItemDefaultDropZone: React.ComponentType<IItemDefaultDropZoneProps> = connectToItemCache((
    itemCache: IItemCache,
    props: IItemDefaultDropZoneProps
): ISelectedActionProps => {
    const {
        itemKey
    } = props;

    const controlHandler = itemCache.demandItemFacet(itemDragDropControl, props.itemKey);

    const {
        itemDropZone: ItemDropZone
    } = itemDragDropControl.evaluate(controlHandler)(itemCache, {
        itemKey,
        itemDropZone: ItemActionDropZone
    });

    return {
        action: evaluateAction(itemCache, (
            <ItemDropZone { ...props } />
        ))
    };
})(ActionSelector);

export type IDefaultDropZoneProps = IDecorateWithCurrentItemProps<IItemDefaultDropZoneProps>;

/**
 * Component which wraps content with a 'drop zone' for the current item in an `ItemsScope`.
 * @beta
 */
export const DefaultDropZone: React.ComponentType<IDefaultDropZoneProps> =
    withCurrentItem()(ItemDefaultDropZone);

/**
 * @internal
 */
export function renderChildrenWithDropZoneElement(
    children: IItemDefaultDropZoneProps['children'],
    dragDropElement: JSX.Element | null
): JSX.Element | null {
    return dragDropElement ?
        React.cloneElement(dragDropElement, undefined, children) :
        renderChildrenWithProps<IActionDropZoneStateProps>(children, DEFAULT_ACTION_DROP_ZONE_STATE_PROPS);
}
